/**
 * 订单信息 orderBaseInfo
 * 申请人信息 orderProppserInfo
 * 浦发业务专项字段 spdBusinessInfo
 * 工作背景 proppserWorkInfo
 * 车辆信息 orderCarInfo
 * 贷款信息 orderLoanInfo
 * 担保人信息 guaranteeInfo
 * 公牌信息 caAppCompanyInfo
 * 放款账户信息 orderLoanAccountInfo
 * 第三方检测结果 todo 待补充 thirdPartyCheckResult
 * 征信报告附件信息 creditAnnexInfo (含4个审批备注)
 * 申请单附件信息 caAppAnnexDTOs
 * 历史审批信息 caAppApprovals
 * 配偶信息 orderRelativeInfo
 * GPS安装信息列表 carGpsInfoList
 */
var formModel = {
  'orderBaseInfo': {
    'status': null,
    'gpsStatus': null,
    'belongDealer': null,
    'dealerCode': null,
    'belongDealerName': null,
    'belongMarket': null,
    'belongMarketName': null,
    'belongOperation': null,
    'belongOperationName': null,
    'belongSale': null,
    'belongSaleManager': null,
    'belongSaleManagerName': null,
    'belongSaleName': null,
    'belongSaleTel': null,
    'comeFrom': null,
    'comeFromName': null,
    'companyName': null,
    'dealerAmt': null,
    'dealerName': null,
    'dealerCityName': null,
    'flowSeq': 0,
    'flowSeqDesc': null,
    'gpsRebate': null,
    'isCompanyLicense': null,
    'isCompanyLicenseDesc': null,
    'isGuaranteedSign': null,
    'isGuaranteedSignName': null,
    'isSpouseSign': null,
    'isSpouseSignName': null,
    'productName': null,
    'productCode': null,
    'rAccountFee': null,
    'rBusinessInsurance': null,
    'rCarloanAmount': null,
    'rComFee': null,
    'rDiscountTrueE': null,
    'rExtendCost': null,
    'rGpsFee': null,
    'rInitPayment': null,
    'rInitScale': null,
    'rLoanAmount': null,
    'rLoanPeriods': null,
    'rLoanRate': null,
    'rRateLevel': null,
    'rSecureFee': null,
    'rTaxPrice': null,
    'rTrafficInsurance': null,
    'rYanbaoFee': null,
    'serFinRebate': null,
    'withholdAmt': null,
    'alifeInsuranceCostFee': null,
    'rlifeInsuranceCostFee': null,
    'rlifeInsuranceProfitFee': null,
    'rGrossInterest': null,
    'bloanRemarks': null,
    'fyRemarks': null,
    'loanRemarks': null,
    'sysaRemarks': null
  },
  'orderProppserInfo': {
    relationDFl: null,
    'address': null,
    'birth': null,
    'city': null,
    'creditRecords': null,
    'district': null,
    'driverType': null,
    'eContact': null,
    'eContactMobile': null,
    'eContactMobileSecret': null,
    'eContacts': null,
    'eContactsMobile': null,
    'eContactsMobileSecret': null,
    'education': null,
    'houseOwner': null,
    'idType': null,
    'idno': null,
    'idnoSecret': null,
    'incomeMonth': null,
    'incomeSource': null,
    'isAssure': null,
    'isDriverLicense': null,
    'marriage': null,
    'mobile': null,
    'mobileSecret': null,
    'nowAddress': null,
    'nowCity': null,
    'nowDistrict': null,
    'nowIndustry': null,
    'nowLivingTime': null,
    'nowPosition': null,
    'nowPostalcode': null,
    'nowProvince': null,
    'nowTel': null,
    'idCardValidEndDate': null,
    'proppserName': null,
    'province': null,
    'relationEContact': null,
    'relationEContacts': null,
    'residenceNature': null,
    'sex': null
  },
  'spdBusinessInfo': {
    'applicationagreementbarcode': null,
    'cardProductCode': null,
    'cardProductName': null,
    'cityCodeStr': null,
    'email': null,
    'marketerCode': null,
    'referenceCode': null,
    'referenceJgcode': null,
    'workTel': null
  },
  'proppserWorkInfo': {
    'firstWorkTime': null,
    'nowCompany': null,
    'nowUnitAddress': null,
    'nowUnitCity': null,
    'nowUnitDistrict': null,
    'nowUnitKind': null,
    'nowUnitPostalcode': null,
    'nowUnitProvince': null,
    'nowUnitScale': null,
    'nowUnitTel': null,
    'nowWorkYear': null
  },
  'orderCarInfo': {
    'aCarCondtion': null,
    'aCarPrice': null,
    'aCarPriceChange': null,
    'carHomePrice': null,
    'carBrand': null,
    'carColor': null,
    'carDiston': null,
    'carFirstBook': null,
    'carGearbox': null,
    'carIdentify': null,
    'carIdentifySecret': null,
    'carMiles': null,
    'carNewPrice': null,
    'carSaleIdno': null,
    'carSaleIdnoSecret': null,
    'carSaleName': null,
    'carSeries': null,
    'carStyles': null,
    'carStyleId': null,
    'carYear': null,
    'engineNo': null,
    'fuelType': null,
    'fuelTypeName': null,
    'icbcAssessmentPrices': null,
    'isOld': null,
    'isOldName': null,
    'measureCompany': null,
    'notarizationFee': null,
    'oldCarAge': null,
    'purpose': null,
    'purposeName': null,
    'transferCnt': null,
    'vinIdentifyChe300': null,
    'vinIdentifyChe300Id': null,
    'floatingPro ': null
  },
  'orderLoanInfo': {
    'carPackagePrice': null,
    'aCarloanAmount': null,
    'aComFee': null,
    'aComRate': null,
    'aInitPayment': null,
    'aInitScale': null,
    'aLoanAmount': null,
    'aLoanPeriods': null,
    'aLoanRate': null,
    'aSecureFee': null,
    'accountFee': null,
    'alifeInsuranceRate': null,
    'chApprovalStatus': null,
    'disaRate': null,
    'discountE': null,
    'discountTrueE': null,
    'gpsCount': null,
    'gpsDealerNo': null,
    'gpsFee': null,
    'gpsLevel': null,
    'gpsPro': null,
    'htScore': null,
    'insuranceCompany': null,
    'insuranceDeposit': null,
    'isGps': null,
    'isGpsDesc': null,
    'isGpsLoan': null,
    'isGpsLoanDesc': null,
    'isHouse': null,
    'isHouseDesc': null,
    'isLcv': null,
    'isLcvDesc': null,
    'lifeInsuranceLevel': null,
    'nonLocalMaterial': null,
    'rateLevel': null,
    'repAccountBank': null,
    'repAccountIdno': null,
    'repAccountIdnoSecret': null,
    'repAccountMobile': null,
    'repAccountMobileSecret': null,
    'repAccountName': null,
    'repAccountNo': null,
    'repAccountNoSecret': null,
    'salePrice': null,
    'transferVoucher': null,
    'transferVoucherDesc': null
  },
  'guaranteeInfo': {
    'address': null,
    'birth': null,
    'city': null,
    'district': null,
    'education': null,
    'firstDriverNo': null,
    'firstWorkTime': null,
    'guaranteeId': null,
    'guaranteeName': null,
    'idNoSecret': null,
    'idType': null,
    'idno': null,
    'incomeMonth': null,
    'incomeOth': null,
    'incomeSource': null,
    'isDriverLicense': null,
    'marriage': null,
    'marriageDesc': null,
    'mobile': null,
    'mobileSecret': null,
    'nowAddress': null,
    'nowCity': null,
    'nowCompany': null,
    'nowDistrict': null,
    'nowIndustry': null,
    'nowLivingTime': null,
    'nowPosition': null,
    'nowPostalcode': null,
    'nowProvince': null,
    'nowTel': null,
    'nowUnitAddress': null,
    'nowUnitCity': null,
    'nowUnitDistrict': null,
    'nowUnitProvince': null,
    'province': null,
    'relationGFl': null,
    'sex': null,
    'sexDesc': null
  },
  'caAppCompanyInfo': {
    'appCode': null,
    'createTime': null,
    'endDate': null,
    'legalName': null,
    'registeredCompanyAddress': null,
    'registeredCompanyCode': null,
    'registeredCompanyId': 9,
    'registeredCompanyName': null,
    'registeredCompanyTel': null,
    'updateTime': null
  },
  'orderLoanAccountInfo': {
    'accountType': null,
    'accountTypeName': null,
    'appCode': null,
    'bankCity': null,
    'bankProvince': null,
    'branchBankCode': null,
    'recAccountBank': null,
    'recAccountBank2': null,
    'recAccountCard': null,
    'recAccountCardSecret': null,
    'recAccountName': null,
    'recAccountNo': null,
    'recAccountNoSecret': null,
    'recordMobile': null,
    'remarks': null
  },
  'riskInfo': {
    'data': [
      {
        'msg': null,
        'orgName': null,
        'reportUrl': null,
        'score': null
      }
    ],
    'idNo': null,
    'lastTime': null,
    'mobile': null,
    'mobileCheck': null,
    'mobileCheck_g': null,
    'mobileCheck_s': null,
    'name': null,
    'riskRsult': null,
    'updateTime': null
  },
  'creditAnnexInfo': {
    'bloanRemarks': null,
    'fyRemarks': null,
    'loanRemarks': null,
    'sysaRemarks': null,
    'caAppAnnexDTOList': [
      {
        'annexAddress': null,
        'annexId': null,
        'annexName': null,
        'annexType': null,
        'createTime': null
      }
    ]
  },
  'caAppAnnexDTOs': [
    {
      'annexAddress': null,
      'annexId': null,
      'annexName': null,
      'annexType': null,
      'createTime': null
    }
  ],
  'caAppApprovals': [
    {
      'appCode': null,
      'approvalTime': null,
      'carId': null,
      'flowName': null,
      'flowNo': null,
      'remarks': null,
      'riskCode': null,
      'riskName': null,
      'status': null,
      'type': null,
      'updateTime': null,
      'userId': null,
      'userName': null
    }
  ],
  'orderRelativeInfo': {
    'address': null,
    'birth': null,
    'city': null,
    'district': null,
    'education': null,
    'idType': null,
    'idno': null,
    'idnoSecret': null,
    'mobile': null,
    'mobileSecret': null,
    'nowAddress': null,
    'nowCity': null,
    'nowCompany': null,
    'nowDistrict': null,
    'nowProvince': null,
    'province': null,
    'relativesName': null,
    'sex': null
  },
  'carGpsInfoList': [],
  'remarks': null
}

export {
  formModel
}



// WEBPACK FOOTER //
// ./src/assets/js/page/approval/refs/orderDetails.formModel.js